(function () {
  app.controller('ModalsCtrl', [
    "$scope", '$timeout', '$compile',
    function ($scope, $timeout, $compile) {
      $scope.is_loading = false;
      $scope.key_search = "";
      $scope.data_search = [];
      $scope.product_list = [];

      $scope.init = function () {};

      $scope.compileContents = function (contents) {
        $compile(contents.contents())($scope);
      }

      $scope.searchBoxes = function (data) {
        $scope.is_loading = true;
        $.ajax({
          beforeSend: function(){
            $(".loading").hide();
            $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
            $(".loading").attr('style', 'z-index: -1 !important');
          },
          url: $scope.search_name_box,
          dataType: "json",
          cache: false,
          type: "POST",
          data: { q: $scope.key_search, except_ids: $scope.product_list.map(p => p.id) },
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed) {
                $scope.data_search = rs.data;
              } else {
                toastr.error("An Unexpected Error Occurred!");
              }
              $scope.is_loading = false;
              tooltipsInit();
            });
          },
        })
      };

      $scope.handleEnter = function($event) {
        $event.preventDefault();
        $scope.searchBoxes();
      };

      $scope.addSelectedProducts = function (box) {
        $scope.product_list.push(box);
        var index = $scope.data_search.indexOf(box);
        if (index > -1) {
          $scope.data_search.splice(index, 1);
        }
        tooltipsInit();
        $scope.updateProductListIds();
      };

      $scope.removeSelectedProducts = function (box) {
        var index = $scope.product_list.indexOf(box);
        if (index > -1) {
          $scope.product_list.splice(index, 1);
        }
        $scope.updateProductListIds();
      };

      $scope.updateProductListIds = function() {
        var productIds = $scope.product_list.map(function(p) { return p.id; });
        $('#product-list').val(productIds.join(','));
      };

      $scope.submitRetailerLink = function (retailer_link) {
        var submitted = (retailer_link == null) ? '' : String(retailer_link).trim();
        var original  = ($scope.original_retailer_link == null) ? '' : String($scope.original_retailer_link).trim();
        // Opened the popup and hit Submit without editing — nothing to do. The server
        // guards this too (it must, since the field is client-side); this just avoids
        // the pointless round trip.
        if (submitted === original) {
          toastr.info("No changes to save.");
          $('#popupModalNew').modal('hide');
          return;
        }
        // An empty field is a removal server-side (it routes to remove_retailer_link),
        // so ask for the same confirmation the Remove link button uses.
        if (!submitted) {
          if (!confirm("Remove this retailer link?\nYour Shopify product will also be unmapped from this box.")) {
            return;
          }
        }
        $scope.is_loading = true;
        $.ajax({
          beforeSend: function(){
            // $(".loading").hide();
            // $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
            // $(".loading").attr('style', 'z-index: -1 !important');
          },
          url: $scope.submit_retailer_links_url,
          dataType: "json",
          cache: false,
          type: "PUT",
          data: { retailer_link: retailer_link },
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed && rs.unchanged) {
                // Server decided nothing changed — no success banner, no reload.
                toastr.info(rs.message || "No changes to save.");
                $('#popupModalNew').modal('hide');
                $scope.is_loading = false;
              } else if (rs.succeed) {
                sessionStorage.setItem('showToastr', 'true');
                sessionStorage.setItem('messageToastr', rs.message);
                $('#popupModalNew').modal('hide');
                Turbolinks.visit(window.location.href);
              } else {
                toastr.error(rs.message || "An Unexpected Error Occurred!");
              }
              $scope.is_loading = false;
            });
          }
        });
      };

      // Removes the retailer link for this box+vendor and unmaps the Shopify product.
      // Uses $.ajax (NOT fetch): rails-ujs installs a jQuery.ajaxPrefilter that adds
      // the X-CSRF-Token header, which fetch would have to set by hand.
      $scope.removeRetailerLink = function () {
        if ($scope.is_loading) { return; }
        if (!confirm("Remove this retailer link?\nYour Shopify product will also be unmapped from this box.")) {
          return;
        }
        $scope.is_loading = true;
        $.ajax({
          url: $scope.remove_retailer_link_url,
          dataType: "json",
          cache: false,
          type: "DELETE",
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed) {
                sessionStorage.setItem('showToastr', 'true');
                sessionStorage.setItem('messageToastr', rs.message);
                $('#popupModalNew').modal('hide');
                Turbolinks.visit(window.location.href);
              } else {
                toastr.error(rs.message || "An Unexpected Error Occurred!");
                $scope.is_loading = false;
              }
            });
          },
          // submitRetailerLink has no error handler and leaves the spinner stuck on
          // 4xx/5xx — do not copy that.
          error: function () {
            $timeout(function () {
              toastr.error("An Unexpected Error Occurred!");
              $scope.is_loading = false;
            });
          }
        });
      };
    }
  ]);

}).call(this);